const accountManagementActionTypes = {
  SET_TEST_ACCOUNT_MANAGEMENT: 'SET_TEST_ACCOUNT_MANAGEMENT',
};

export default accountManagementActionTypes;
